var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMistral = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M29.09 1.455h-5.817v5.818h5.818z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#F7D046",
  d: "M32 1.455h-5.818v5.818H32z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M5.818 1.455H0v5.818h5.818zM5.818 7.273H0v5.818h5.818z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M5.818 13.09H0v5.82h5.818zM5.818 18.91H0v5.817h5.818zM5.818 24.727H0v5.819h5.818z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#F7D046",
  d: "M8.727 1.455H2.91v5.818h5.818z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#F2A73B",
  d: "M32 7.273h-5.818v5.818H32zM8.727 7.273H2.91v5.818h5.818z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M23.273 7.273h-5.818v5.818h5.818z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#F2A73B",
  d: "M26.182 7.273h-5.818v5.818h5.818zM14.545 7.273H8.727v5.818h5.818z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#EE792F",
  d: "M20.364 13.09h-5.819v5.82h5.819z"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "#EE792F",
  d: "M26.182 13.09h-5.818v5.82h5.818zM14.545 13.09H8.727v5.82h5.818z"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M17.455 18.91h-5.819v5.817h5.819z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#EB5829",
  d: "M20.364 18.91h-5.819v5.817h5.819z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#EE792F",
  d: "M32 13.09h-5.818v5.82H32zM8.727 13.09H2.91v5.82h5.818z"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M29.09 18.91h-5.817v5.817h5.818z"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "#EB5829",
  d: "M32 18.91h-5.818v5.817H32z"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M29.09 24.727h-5.817v5.819h5.818z"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "#EB5829",
  d: "M8.727 18.91H2.91v5.817h5.818z"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fill: "#EA3326",
  d: "M32 24.727h-5.818v5.819H32zM8.727 24.727H2.91v5.819h5.818z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMistral);
export default ForwardRef;